import { AorManager } from 'components/GroupsRoute/aorEditor/AorManager';
import { useAorText } from 'utils/aorTerminology';

export function AorStep() {
  const aorText = useAorText();
  return (
    <div className="tw:flex tw:flex-col tw:gap-3">
      <div>
        <h3 className="tw:m-0 tw:text-sm tw:font-semibold">
          {aorText('Define your Areas of Responsibility')}
        </h3>
        <p className="tw:m-0 tw:text-sm tw:text-muted-foreground">
          {aorText(
            'AORs are the places your organization covers. Reports, alerts, and automation rules are scoped to them.'
          )}
        </p>
      </div>
      <AorManager compact />
    </div>
  );
}
